'use es6';

import * as ActionTypes from '../actions/ActionTypes';
var initialState = null;
export default function emailFormState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.SET_EMAIL_FORM:
      return action.payload;

    case ActionTypes.RESET_EMAIL_FORM:
      return initialState;

    default:
      return state;
  }
}